import styled from 'styled-components'
import { Row, Col } from 'react-styled-flexboxgrid-tmp'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { HYPER_LINK_COLOR_LIGHT, UNIVERSAL_COLOR } from '@CSSVars/colors'


export const _DesktopDisclaimerNotification = styled.div`
  width: 100%;
  min-height: 48px;
  padding: 12px 24px;
  margin-bottom: 8px;
  text-align: center;
  background-color: ${HYPER_LINK_COLOR_LIGHT};
  p {
    max-width: 1140px;
    margin: 0 auto;
    line-height: 22px;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const _MobileDisclaimerNotification = styled(_DesktopDisclaimerNotification)`
  display: none;
  margin-bottom: 0;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: block;
  }
`


export const _Section = styled.section`
  position: relative;
  width: calc(100% - 128px);
  max-width: 1140px;
  margin: 0 auto;
  padding: 0;
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
  .open_house_banner {
    width: 260px;
    top: 12px;
    left: 12px;
    border-radius: 4px;
  }
`

export const _ImageContainer = styled(Row)`
  height: 100%;
  margin: 0;
  position: relative;
  div {
    font-size: 0;
  }
`

export const _LeftImageCol = styled(Col)`
  width: calc(63% - 2px);
  height: 100%;
  margin: 0;
  padding: 0;
  margin-right: 2px;
  >div {
    height: 100%;
    width: 100%;

    >div {
      height: 100%;
      width: 100%;
    }
  }
  img {
    min-width: 100% !important;
    min-height: 100% !important;
    display: block;
    object-fit: cover;
  }
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
`

export const _RightImageCol = styled(Col)`
  width: calc(37% - 2px);
  margin: 0;
  padding: 0;
  height: 100%;
  margin-left: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  > div {
    &:first-child {
      margin-bottom: 4px;
      //transform: translateY(50%);
    }
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 1023px) {
    display: none;
  }
`

// To make the min height div for image before loading
export const _PhotoGridWrap = styled.div`
  overflow-y: hidden;
  position: relative;
  padding-bottom: 420px;
  cursor: pointer;
  @media screen and (max-width: 1023px) {
    padding-bottom: 453px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding-bottom: ${({ isMobileApp }) => (
    isMobileApp ? '72%' : '59%'
  )};

    .embla__dots {
      bottom: 28px !important;
    }
  }

  @media screen and (min-width: ${BREAK_POINT_LG}) {
    border-radius: 10px;
    overflow: hidden;
  }

  @media screen and (min-width: ${BREAK_POINT_LG}) {
    border-radius: 10px;
    overflow: hidden;
  }
`

// To make the min height div for image before loading
export const _PhotoGridHolder = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  ${({ blured }) => (
    blured ?
      `
        filter: blur(8px);
        pointer-events: none;
      ` : ''
  )}
`

export const _OverlayCtaContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 10;
  @media screen and (max-width: 1200px) {
    -webkit-transform: translate(-50%, -55%);
    transform: translate(-50%, -55%);
  }
  @media screen and (max-width: 767px) {
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
`

export const _ImageCounter = styled.div`
  width: 37px;
  height: 21px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 12px;
  background: rgba(16, 16, 16, 0.6);
  color: white;
  border-radius: 2px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    bottom: 30px;
  }
`
export const _VT = styled.div`
  width: 30px;
  height: 21px;
  position: absolute;
  bottom: 10px;
  right: 50px;
  font-size: 12px;
  background: rgba(16, 16, 16, 0.6);
  border-radius: 2px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  svg{
    fill: white;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    bottom: 30px;
  }
`

export const _TagBlock = styled.div`
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 1;
  padding: 3px 8px;
  display: flex;
  align-items: center;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  line-height: 15px;
  margin-right: 8px;
  height: auto;
  background: ${UNIVERSAL_COLOR};
  div {
    font-size: inherit;
    color: inherit;
    line-height: inherit;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: fit-content;
  }
  `
